import get from "lodash/get"

import { OccupantData } from "providers/venue/types"
import { VAT_REFUND_CATEGORY_REF } from "extensions/iconsiam/constants"

export const hasVatRefund = (occupant?: OccupantData): boolean =>
  (get(occupant, "properties.local_parent_categories") ?? []).some(
    (category) =>
      get(category, "properties.reference") === VAT_REFUND_CATEGORY_REF
  )

/**
 * Removes the VAT-refund parent category from `properties.local_parent_categories`
 * so downstream category derivation (getFeatureDetail/getOccupantDetail) shows the
 * occupant's real category instead of "VAT Refund".
 */
export const excludeVatRefundCategory = <T extends { properties?: any }>(
  occupant?: T
): T => {
  const localParentCategories = get(
    occupant,
    "properties.local_parent_categories"
  )
  if (!localParentCategories?.length) return occupant as T

  return {
    ...occupant,
    properties: {
      ...occupant.properties,
      local_parent_categories: localParentCategories.filter(
        (category) =>
          get(category, "properties.reference") !== VAT_REFUND_CATEGORY_REF
      ),
    },
  } as T
}
